import React from 'react';
import { getCurrentLocale } from '../services/api';
import { useGA4 } from '../hooks/useGA4';
import { ArrowLeft, ArrowRight } from './icons';

interface SlotMachineButtonProps {
  text: string;
  icon: React.ReactNode;
  href: string;
  className?: string;
  style?: React.CSSProperties;
  variant?: 'primary' | 'secondary' | 'tertiary';
  width?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export function SlotMachineButton({ 
  text, 
  icon, 
  href, 
  className = '',
  style,
  variant = 'secondary',
  width,
  onClick
}: SlotMachineButtonProps) {
  const buttonClasses = `slot-machine-button slot-machine-button--${variant} ${className}`.trim();
  const { trackEvent } = useGA4();
  
  const buttonStyles: React.CSSProperties = {
    width: width || 'auto',
    ...style
  };

  const handleClick = (e: React.MouseEvent) => {
    console.log('🔘 SlotMachineButton clicked', { href, hasOnClick: !!onClick, text });
    
    // If onClick is provided, prevent default navigation
    if (onClick) {
      console.log('🔘 Preventing default navigation');
      e.preventDefault();
    }
    
    // Track CTA button click
    trackEvent('cta_button_click', {
      button_text: text,
      button_url: href,
      button_variant: variant,
      button_location: className.includes('hero') ? 'hero' : 
                      className.includes('footer') ? 'footer' : 
                      className.includes('contact') ? 'contact' : 'unknown'
    });
    
    if (onClick) {
      console.log('🔘 Calling onClick handler');
      onClick(e);
    }
  };

  // Swap arrow direction automatically for RTL locales (e.g., Arabic)
  const locale = typeof window !== 'undefined' ? getCurrentLocale() : 'nl';
  let renderedIcon = icon;
  if (locale === 'ar' && React.isValidElement(icon)) {
    try {
      if (icon.type === ArrowRight) {
        renderedIcon = <ArrowLeft {...(icon as any).props} />;
      }
    } catch (_) {
      // fail silently
    }
  }

  return (
    <a 
      href={href} 
      className={buttonClasses}
      style={buttonStyles}
      onClick={handleClick}
    >
      {/* Text with slot machine effect */}
      <div className="slot-machine-text">
        <span className="slot-machine-text-visible">
          {text}
        </span>
        <span className="slot-machine-text-hidden">
          {text}
        </span>
      </div>
      
      {/* Icon */}
      <span className="slot-machine-icon">
        {renderedIcon}
      </span>
    </a>
  );
} 